import {api} from '../helpers/api';
import utils from '../helpers/utils';

type mergeAccountPayload = {
  showMergeAccountBanner: boolean;
  huid: string;
};

export const ACCOUNT_IS_MERGE_ELIGIBLE_REQUEST = 'ACCOUNT_IS_MERGE_ELIGIBLE_REQUEST';
export const ACCOUNT_IS_MERGE_ELIGIBLE_SUCCESS = 'ACCOUNT_IS_MERGE_ELIGIBLE_SUCCESS';
export const ACCOUNT_IS_MERGE_ELIGIBLE_FAILURE = 'ACCOUNT_IS_MERGE_ELIGIBLE_FAILURE';

export function isMergeAccountEligibleRequest() {
  return {
    type: ACCOUNT_IS_MERGE_ELIGIBLE_REQUEST,
  };
}

/**
 * Upon merge account api success return object with success type and api response payload
 *
 * @return {Object} - Object containing merge account success type and api response payload
 */
export function isMergeAccountEligibleSuccess(payload: mergeAccountPayload) {
  return {
    type: ACCOUNT_IS_MERGE_ELIGIBLE_SUCCESS,
    payload,
  };
}

export function isMergeAccountEligibleFailure() {
  return {
    type: ACCOUNT_IS_MERGE_ELIGIBLE_FAILURE,
  };
}

/**
 * Setup api config and fetch account merge eligibility data
 * @return {function} - Thunk to be dispatched
 */
export function isMergeAccountEligible() {
  const url = utils.getMergeAccountPath();
  const config: FetchConfig = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      client_id: window.MODE === 'DWM' ? 'dwm' : 'dsp',
    },
    credentials: 'include',
  };
  return api(
    url,
    config,
    isMergeAccountEligibleRequest(),
    isMergeAccountEligibleSuccess,
    isMergeAccountEligibleFailure
  );
}
